@if (isOpen) {
    <div class="dropdown-menu">
        <app-profile [isInToolbar]="true"></app-profile>
    </div>
}
